var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg01"},[_c('Head',{attrs:{"title":"消息通知"}}),_c('el-row',{staticClass:"mod08"},[_c('el-col',{attrs:{"span":24}},[_c('h2',{staticClass:"color999"},[_vm._v(_vm._s(_vm.formatDate(_vm.obj.AcquitAt)))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.obj.Content)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }